jQuery(function ($) {
  const sections = $('[data-videoGrid]');

  $.each(sections, function () {
    const section       = $(this);
    const items         = section.find('[data-item]');
    const modals        = section.find('[data-modal]');
    const modalTrigger  = section.find('[data-modal-trigger]');
    const modalClose    = section.find('[data-modal-close]');
    const modalBackdrop = section.find('[data-modal-backdrop]');

    let focusElement = false;

    function closeModals () {
      modals.removeClass('is-open');

      if (focusElement.length > 0) {
        focusElement.focus();
      }

      // remove src from iframes to stop playback
      modals.find('iframe[src], video[src]').each(function () {
        const iframe = $(this);
        iframe.attr('data-src', iframe.attr('src')).removeAttr('src');
      });
    }

    modalTrigger.on('click', function (e) {
      const modal = modals.filter('[data-modal="' + $(this).data('modalTrigger') + '"]');
      const iframe = modal.find('iframe[data-src], video[data-src]');

      focusElement = $(':focus');
      modal.addClass('is-open').focus();

      // restore iframe src
      if (iframe) {
        iframe.attr('src', iframe.data('src'));
      }
    });

    modalClose.on('click', closeModals);
    modalBackdrop.on('click', closeModals);

    $(document).on('keyup', function (e) {
      if (e.keyCode === 27) {
        closeModals();
      }
    });

    // add youtube thumbnails from borlabs cache
    items.each(function () {
      const item = $(this);
      const thumbnailSrc = item.find('._brlbs-thumbnail').attr('data-src');

      if (thumbnailSrc) {
        item.find('[data-thumbnail]').html('<img data-src="' + thumbnailSrc + '" alt="" class="thumbnail-background thumbnail-background--image thumbnail-background--youtube lazyload">')
      }
    })
  })
});
